import { ALERT } from '../actions/types'

const initialState = [];

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
        case ALERT.AGREGAR:
            return [...state, payload];

        case ALERT.ELIMINAR:
            return state.filter( alert => alert.id !== payload.id );
            
        default:
            return state;
    }
}